import ErrorBanner from "components/ui/ErrorBanner";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { muiTheme } from "../styles/muiTheme";
import { ErrorBoundary } from "components/ErrorBoundary";
import DictionaryTools from "app/DictionaryTools/DictionaryTools";
import { LocalizationProvider } from "contexts/LocalizationContext";
import { OnboardingContextProvider } from "contexts/OnboardingContext";
import { ToastProvider } from "contexts/ToastContext";
import { UserContextProvider } from "contexts/UserContext";
import {
  createBrowserRouter,
  createRoutesFromChildren as createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./App.scss";
import { Layout } from "./Layout";
import { queryClient } from "./global";
import { RouteList } from "./routing/RouteList";

export function AppShell() {
  return (
    <QueryClientProvider client={queryClient}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={muiTheme}>
          <RouterProvider router={router} />
        </ThemeProvider>
      </StyledEngineProvider>
      {/* Disabled in production build */}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="*"
      element={
        <UserContextProvider>
          <LocalizationProvider>
            <ToastProvider>
              <OnboardingContextProvider>
                <App />
              </OnboardingContextProvider>
            </ToastProvider>
          </LocalizationProvider>
        </UserContextProvider>
      }
    />
  )
);

function App() {
  const { t } = useTranslation();

  return (
    <div className="App">
      <ErrorBoundary
        fallback={<ErrorBanner>{t("Common.errors.somethingWrong")}</ErrorBanner>}
      >
        <DictionaryTools>
          <Layout>
            <RouteList />
          </Layout>
        </DictionaryTools>
      </ErrorBoundary>
    </div>
  );
}
